<app-protected-content [requiredRoles]="requiredRoles" [requireApprovedOrganization]="true">
<div class="container" *transloco="let t; prefix: 'organization.member.add'">
  <htx-button variant="tertiary" icon="arrow_back" (click)="cancel()">{{ 'button.back' | transloco }}</htx-button>

  <div class="panel">
    <div class="edit-header">
      <div class="header-title-section">
        <h1 class="header-title">{{ t('header') }}</h1>
        <p class="header-subtitle">{{ t('subtitle') }}</p>
      </div>
      <htx-button
        variant="primary"
        icon="person_add"
        (click)="save()"
        [disabled]="form.invalid"
      >
        {{ 'button.invite' | transloco }}
      </htx-button>
    </div>

    <div class="form-sections">
      <htx-form-section
        [title]="t('sections.memberInfo')"
        [icon]="'person'"
        [formGroup]="form"
        [controlNames]="['firstName', 'lastName', 'email']"
        [fieldLabels]="fieldLabels"
      >
        <htx-text-field-with-error
          [ctrl]="form.controls.firstName"
          [label]="t('controls.firstName.label')"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>

        <htx-text-field-with-error
          [ctrl]="form.controls.lastName"
          [label]="t('controls.lastName.label')"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>

        <htx-text-field-with-error
          [ctrl]="form.controls.email"
          [label]="t('controls.email.label')"
          type="email"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
      </htx-form-section>

      <htx-form-section
        [title]="t('sections.permissions')"
        [icon]="'shield'"
      >
        <div class="roles-grid" [formGroup]="form">
          <div formGroupName="roles" class="roles-checkboxes">
            @for (role of assignableRoles; track role) {
              <htx-checkbox-field
                [ctrl]="form.get('roles')!.get(role)!"
                [label]="'organization.member.roles.labels.' + role.toLowerCase() | transloco"
              ></htx-checkbox-field>
            }
          </div>
        </div>
      </htx-form-section>
    </div>
  </div>
</div>
</app-protected-content>
